import React, { useEffect } from 'react'
import { PasswordFieldSeeker } from "@ui-seeker/core"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { editUserId, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"

import { object, string } from "yup"
import { useValidatorSeeker } from "@app"

export default function UserPasswordField() {

	const { password, setPasswordInfo } = useAdminUsersInfo(userPayload.peek()?.user?.password, "password", "user")

	const { errors, isValid } = useValidatorSeeker(
		{ password: password },
		object({
			...!editUserId.value && {
				password: string()
					.min(8, 'Password must be at least 8 characters long')
					.matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
					.matches(/[a-z]/, 'Password must contain at least one lowercase letter')
					.matches(/\d/, 'Password must contain at least one number')
					.matches(/[@$!%*?&]/, 'Password must contain at least one special character')
					.required('Must provide a password')
			}
		})
	)


	useEffect(() => {
		userErrorRegistry.value = { ...userErrorRegistry.peek(), password: isValid }
	}, [isValid])

	return <PasswordFieldSeeker
		value={password}
		onChange={e => setPasswordInfo(e.target.value)}
		error={errors?.password}
		inputProps={{ autoComplete: 'new-password' }}
	/>
}